import { DoodDeclinableModel } from '@core/models/product.model';
import { ProductKeys } from '@config/keys/product.keys';

export class DeclinableUtils {
  static countAdditionOccurrences(additions: string[]): Occurrence[] {
    return Array.from(
      additions
        .reduce((map, item) => {
          map.set(item, (map.get(item) || 0) + 1);
          return map;
        }, new Map<string, number>())
        .entries(),
    ).map(([id, quantity]) => ({ id, quantity: quantity }));
  }

  static isDeclinableCategoryValid(item: DoodDeclinableModel): boolean {
    const selectedCount = item.selected?.length ?? 0;
    if ((item.min_count ?? 0) > 0 && selectedCount < item.min_count) {
      return false;
    }
    if (item.count != null && item.count > 0 && selectedCount > item.count) {
      return false;
    }

    for (const selected of item.selected ?? []) {
      const product = item.products.find(
        compoundProduct => compoundProduct[ProductKeys.Id] === selected.id,
      );
      if (
        product?.additions_group_informations?.some(
          group => !DeclinableUtils.isMandatoryAdditionGroupSatisfied(group),
        )
      ) {
        return false;
      }
    }

    return true;
  }

  private static isMandatoryAdditionGroupSatisfied(group: {
    min_count?: number;
    isValid?: boolean;
    selectedItems?: { quantity?: number }[];
    count?: number;
  }): boolean {
    const minCount = group.min_count ?? 0;
    if (minCount <= 0) {
      return true;
    }

    if (group.isValid === true) {
      return true;
    }

    const selectedCount =
      group.selectedItems?.reduce((sum, item) => sum + (item.quantity ?? 1), 0) ?? 0;

    if (group.isValid === false) {
      return selectedCount >= minCount;
    }

    return (group.count ?? selectedCount) >= minCount;
  }

  static areAllDeclinableCategoriesValid(items: DoodDeclinableModel[]): boolean {
    return items.every(item => DeclinableUtils.isDeclinableCategoryValid(item));
  }
}

interface Occurrence {
  id: string;
  quantity: number;
}
